module.exports = __webpack_public_path__ + "static/portfolio_gallery_14-7fb541f8b48a867819898787d806b6d4.jpg";